<h2 class="mb-0" mat-dialog-title>{{ data.SchoolName }}</h2>
<p class="mb-4 address">{{ data.StreetAddress1 || data.StreetAddress2 }}</p>
<button class="close m-3" mat-button (click)="closeDialog()">
  <mat-icon>close</mat-icon>
</button>
<mat-dialog-content class="dialog-content">
  <p><b>Phone:</b> {{ data.ContactPhone }}</p>
  <p><b>Grade:</b> {{ data.SchoolGradeLevel }}</p>
  <p><b>Distance:</b> {{ data.Distance || '--' }} km</p>
</mat-dialog-content>
